/* eslint-disable no-restricted-globals */
// https://stackoverflow.com/questions/43503964/onkeydown-event-not-working-on-divs-in-react
// onKeyDown behavior added to make Google Map useable through keyboard navigation. 
import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import './marker.scss';

const Marker = (props) => {
  const selectedClass = props.selected ? 'sb-marker-selected' : '';
  const services = [];
  if (props.servicesTags && props.servicesTags.length) {
    props.servicesTags.map((servicesTag) => {
      return services.push(`sb-marker-service--${servicesTag}`);
    });
  }

  return (
      <div
        aria-label={`${i18n.t('location')}-${props.location.location_name}`}
        className={`sb-marker sb-marker-${props.type} ${selectedClass} ${services.join(' ')} ${props.location.matches_filters ? 'sb-marker-matches-filters' : ''}`}
        onKeyDown={ () => { props.handleMarkerKeyPress(event, props.location.id.toString()); } }
        role="button"
        tabIndex={0}
      >
        {props.text}{props.popover}
      </div>
  );
};

Marker.propTypes = {
  handleMarkerKeyPress: PropTypes.func,
  location: PropTypes.object,
  popover: PropTypes.string,
  postSearchFilters: PropTypes.array,
  selected: PropTypes.bool,
  selectedClass: PropTypes.string,
  servicesFilters: PropTypes.array,
  servicesTags: PropTypes.array,
  text: PropTypes.string,
  type: PropTypes.string,
};

export default Marker;
